import { useMutation } from 'convex/react';
import { api } from '../../../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: benefit-plan-tabs subdirectory requires four levels up to reach convex/_generated/
import { EditableJsonTable } from './EditableJsonTable';
import type {
  IBenefitPlan,
  IBenefitSection,
  IBenefitItem,
  IPreAuthRequirement,
} from '@/@types/claims';
import type { IEditableJsonTableColumn } from '@/@types/insurance';

interface IPreAuthRequirementsTabProps {
  // LOCAL_TYPE_JUSTIFIED: component-specific props combining plan with enriched sections
  plan: IBenefitPlan & {
    sections: Array<IBenefitSection & { items: IBenefitItem[] }>;
  };
}

const COLUMNS: IEditableJsonTableColumn<IPreAuthRequirement>[] = [
  { key: 'id', header: 'ID', width: '50px', readOnly: true },
  { key: 'requiredFor', header: 'Required For' },
  { key: 'thresholdOrDetail', header: 'Threshold / Detail', width: '200px' },
  { key: 'timing', header: 'Timing', width: '120px' },
  {
    key: 'penaltyIfNotObtained',
    header: 'Penalty if Not Obtained',
    width: '200px',
    variant: 'danger',
  },
  { key: 'notes', header: 'Notes', width: '160px' },
];

export function PreAuthRequirementsTab({ plan }: IPreAuthRequirementsTabProps) {
  const updateTabData = useMutation(api.insurance.benefitPlans.updateTabData);

  const rows: IPreAuthRequirement[] = (plan.preAuthRequirements ?? []).map((r, i) => ({
    ...r,
    id: r.id || `P${i + 1}`,
  }));

  async function handleSave(updated: IPreAuthRequirement[]) {
    await updateTabData({ planId: plan._id, field: 'preAuthRequirements', data: updated });
  }

  return (
    <div className="py-6 px-8">
      <EditableJsonTable
        rows={rows}
        columns={COLUMNS}
        idPrefix="P"
        onSave={handleSave}
        emptyMessage="No pre-auth requirements defined."
      />
    </div>
  );
}
